import {Component, Input} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {QuestionBase} from '../domain/question.base';

export abstract class QuestionComponent {
  @Input() question: QuestionBase<any>;
  @Input() form: FormGroup;

  get isInvalid() {
    return this.form.touched && this.form.invalid;
  }

  get show() {
    return (this.question.showIfPopulated !== true || (this.form.value)) && this.question.show !== false;
  }

  get value() {
    return this.form.get(this.question.key).value || [];
  }

  get showIf() {
    if (this.question.showIf.key === '' || this.question.showIf.value === '') {
      return true;
    }

    let result: boolean = false;
    // look on this form (group) first
    if (this.form.get(this.question.showIf.key)) {
      result = this.evaluate(this.form);
    } else if (this.form.parent && this.form.parent.get(this.question.showIf.key)) {
      result = this.evaluate(this.form.parent);
    }

    // Make sure form validation respects visibility
    if (result) {
      if (!this.form.get(this.question.key).enabled) {
        this.form.get(this.question.key).enable();
      }
    } else {
      if (this.form.get(this.question.key).enabled) {
        this.form.get(this.question.key).disable();
      }
    }

    return result;
  }

  private evaluate(form: AbstractControl) {

    if (typeof this.question.showIf.value === 'string') {
      return form.get(this.question.showIf.key).value === this.question.showIf.value;
    }

    switch (Object.keys(this.question.showIf.value)[0]) {
      case '$ne':
        return form.get(this.question.showIf.key).value !== this.question.showIf.value.$ne;
      case '$eq':
        return form.get(this.question.showIf.key).value === this.question.showIf.value.$eq;
      case '$gt':
        return form.get(this.question.showIf.key).value > this.question.showIf.value.$gt;
      case '$lt':
        return form.get(this.question.showIf.key).value < this.question.showIf.value.$lt;
      case '$gte':
        return form.get(this.question.showIf.key).value >= this.question.showIf.value.$gte;
      case '$lte':
        return form.get(this.question.showIf.key).value <= this.question.showIf.value.$lte;
      default :
        return false;
    }
  }
}
